import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

const ProductsCardSkeleton = () => {
  const { colors } = useTheme();

  return (
    <ContentLoader
      width="280"
      height="400"
      backgroundColor={colors.gray_300}
      foregroundColor={colors.gray_200}
      style={{ borderRadius: 4, background: colors.gray_100, marginTop: 30 }}
    >
      <rect x={20} y={20} width="100" height="15" />
      <rect x={20} y={45} width="100" height="60" />
      <rect x={20} y={115} width="100" height="15" />
      <rect x={20} y={135} width="100" height="15" />

      <rect x={20} y={275} width="100" height="15" />
      <rect x={20} y={295} width="240" height="35" />

      <rect x={0} y={350} width="280" height="50" />
    </ContentLoader>
  );
};

export default ProductsCardSkeleton;
